import React, { useState } from "react";
import {
  Box,
  TextField,
  Button,
  Typography,
  Alert,
  Collapse,
  Link,
  Stack,
} from "@mui/material";

const CouponCodeInput = ({ onApply, onRemove, appliedCode, error }) => {
  const [input, setInput] = useState("");
  const [touched, setTouched] = useState(false);
  const [expanded, setExpanded] = useState(false);

  const handleApply = () => {
    if (input.trim()) {
      onApply(input.trim().toUpperCase());
      setTouched(true);
    }
  };

  const handleRemove = () => {
    setInput("");
    setTouched(false);
    setExpanded(false);
    onRemove();
  };

  return (
    <Box mt={4} mb={2} p={2} sx={{ border: "1px solid #eee", borderRadius: 2 }}>
      {!expanded && !appliedCode && (
        <Typography variant="body2">
          <Link
            component="button"
            underline="hover"
            onClick={() => setExpanded(true)}
            sx={{ fontWeight: 500 }}>
            Click to enter a promo code if you have any
          </Link>
        </Typography>
      )}

      <Collapse in={expanded || !!appliedCode} unmountOnExit>
        <Stack spacing={1} mt={1}>
          <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
            Coupon Code
          </Typography>
          <Box display="flex" gap={1} alignItems="center">
            <TextField
              size="small"
              placeholder="Enter code"
              value={input}
              onChange={(e) => setInput(e.target.value)}
              fullWidth
              disabled={!!appliedCode}
            />
            {!appliedCode && (
              <Button variant="contained" onClick={handleApply}>
                Apply
              </Button>
            )}
          </Box>

          {!!error && touched && <Alert severity="error">{error}</Alert>}

          {!!appliedCode && !error && (
            <Typography
              variant="body2"
              color="success.main"
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}>
              Code applied: <strong>{appliedCode}</strong>
              <Link
                component="button"
                underline="hover"
                onClick={handleRemove}
                sx={{ ml: 2 }}>
                Remove
              </Link>
            </Typography>
          )}
        </Stack>
      </Collapse>
    </Box>
  );
};

export default CouponCodeInput;
